<template>
  <ManagementPane />
</template>

<script setup>
import ManagementPane from "../components/ManagementPane/index.vue";
</script>
